export const storeFields = /* GraphQL */ `
  fragment storeFields on Store {
    path
    displayable {
      name
      avatar {
        image_public_id
      }
    }
  }
`
